
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brighton/seo-design-portfolio/web-design-for-tradesmen",
      function () {
        return require("private-next-pages/brighton/seo-design-portfolio/web-design-for-tradesmen/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brighton/seo-design-portfolio/web-design-for-tradesmen"])
      });
    }
  